import { StyleGroupDefinition, StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [
	{
		n: 'gridPaddingLeft',
		cp: 'padding-left',
		dn: 'Grid Left padding',
		de: 'Left padding for grid.',
		sel: '.comp.compGrid._noAnchorGrid',
	},
	{
		n: 'gridPaddingRight',
		cp: 'padding-right',
		dn: 'Grid Right padding',
		de: 'Right padding for grid.',
		sel: '.comp.compGrid._noAnchorGrid',
	},
	{
		n: 'gridPaddingTop',
		cp: 'padding-top',
		dn: 'Grid Top padding',
		de: 'Top padding for grid.',
		sel: '.comp.compGrid._noAnchorGrid',
	},
	{
		n: 'gridPaddingBottom',
		cp: 'padding-bottom',
		dn: 'Grid Bottom padding',
		de: 'Bottom padding for grid.',
		sel: '.comp.compGrid._noAnchorGrid',
	},
	{
		n: 'anchoredGridPaddingLeft',
		cp: 'padding-left',
		dn: 'Grid Left padding',
		de: 'Left padding for grid.',
		sel: '.comp.compGrid ._anchorGrid',
	},
	{
		n: 'anchoredGridPaddingRight',
		cp: 'padding-right',
		dn: 'Grid Right padding',
		de: 'Right padding for grid.',
		sel: '.comp.compGrid ._anchorGrid',
	},
	{
		n: 'anchoredGridPaddingTop',
		cp: 'padding-top',
		dn: 'Grid Top padding',
		de: 'Top padding for grid.',
		sel: '.comp.compGrid ._anchorGrid',
	},
	{
		n: 'anchoredGridPaddingBottom',
		cp: 'padding-bottom',
		dn: 'Grid Bottom padding',
		de: 'Bottom padding for grid.',
		sel: '.comp.compGrid ._anchorGrid',
	},
	{
		n: 'gapBetween',
		cp: 'gap',
		dn: 'Gap between children',
		de: 'Gap between children of grid.',
		dv: '5px',
		sel: '.comp.compGrid._noAnchorGrid, .comp.compGrid ._anchorGrid',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border Light',
		n: 'borderLight',
		dv: '1px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._LIGHT, .comp.compGrid ._anchorGrid._LIGHT',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border Medium',
		n: 'borderMedium',
		dv: '3px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._MEDIUM, .comp.compGrid ._anchorGrid._MEDIUM',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border High',
		n: 'borderHigh',
		dv: '5px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._HEAVY, .comp.compGrid ._anchorGrid._HEAVY',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border Extreme',
		n: 'borderExtreme',
		dv: '8px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._EXTREME, .comp.compGrid ._anchorGrid._EXTREME',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border Ultra',
		n: 'borderUltra',
		dv: '10px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._ULTRA, .comp.compGrid ._anchorGrid._ULTRA',
		np: true,
	},
	{
		gn: 'Border',
		dn: 'Border Maximum',
		n: 'borderMaximum',
		dv: '12px solid',
		cp: 'border',
		sel: '.comp.compGrid._noAnchorGrid._MAXIMUM, .comp.compGrid ._anchorGrid._MAXIMUM',
		np: true,
	},

	{
		gn: 'Border Radius',
		dn: 'Border Radius Straight',
		n: 'borderRadiusStraight',
		dv: '0px ',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._STRAIGHT, .comp.compGrid ._anchorGrid._STRAIGHT',
		np: true,
	},
	{
		gn: 'Border Radius',
		dn: 'Border Radius Slight Round',
		n: 'borderRadiusSlightRound',
		dv: '5px',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._SLIGHTROUND, .comp.compGrid ._anchorGrid._SLIGHTROUND',
		np: true,
	},
	{
		gn: 'Border Radius',
		dn: 'Border Radius Round',
		n: 'borderRadiusRound',
		dv: '10px',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._ROUND, .comp.compGrid ._anchorGrid._ROUND',
		np: true,
	},
	{
		gn: 'Border Radius',
		dn: 'Border Radius Extra Round',
		n: 'borderRadiusExtraRound',
		dv: '15px',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._EXTRAROUND, .comp.compGrid ._anchorGrid._EXTRAROUND',
		np: true,
	},
	{
		gn: 'Border Radius',
		dn: 'Border Radius Very Round',
		n: 'borderRadiusVeryRound',
		dv: '20px ',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._VERYROUND, .comp.compGrid ._anchorGrid._VERYROUND',
		np: true,
	},
	{
		gn: 'Border Radius',
		dn: 'Border Radius Full Round',
		n: 'borderRadiusFullRound',
		dv: '30px',
		cp: 'border-radius',
		sel: '.comp.compGrid._noAnchorGrid._FULLROUND, .comp.compGrid ._anchorGrid._FULLROUND',
		np: true,
	},

	{
		gn: 'Box Shadow',
		dn: 'Box Shadow DarkLow',
		n: 'boxShadowDarkLow',
		dv: '0px 3px 10px 0px rgba(255, 255, 255, 0.10)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._DARKLOW, .comp.compGrid ._anchorGrid._DARKLOW',
		np: true,
	},
	{
		gn: 'Box Shadow',
		dn: 'Box Shadow DarkMedium',
		n: 'boxShadowDarkMedium',
		dv: '0px 5px 20px 0px rgba(255, 255, 255, 0.20)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._DARKMEDIUM, .comp.compGrid ._anchorGrid._DARKMEDIUM',
		np: true,
	},
	{
		gn: 'Box Shadow',
		dn: 'Box Shadow DarkHigh',
		n: 'boxShadowDarkHigh',
		dv: '0px 5px 30px 0px rgba(255, 255, 255, 0.30)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._DARKHIGH, .comp.compGrid ._anchorGrid._DARKHIGH',
		np: true,
	},
	{
		gn: 'Box Shadow',
		dn: 'Box Shadow LightLow',
		n: 'boxShadowLightLow',
		dv: '0px 3px 10px 0px rgba(0, 0, 0, 0.10)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._LIGHTLOW, .comp.compGrid ._anchorGrid._LIGHTLOW',
		np: true,
	},
	{
		gn: 'Box Shadow',
		dn: 'Box Shadow LightMedium',
		n: 'boxShadowLightMedium',
		dv: '0px 5px 20px 0px rgba(0, 0, 0, 0.20)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._LIGHTMEDIUM, .comp.compGrid ._anchorGrid._LIGHTMEDIUM',
		np: true,
	},
	{
		gn: 'Box Shadow',
		dn: 'Box Shadow LightHigh',
		n: 'boxShadowLightHigh',
		dv: '0px 5px 30px 0px rgba(0, 0, 0, 0.30)',
		cp: 'box-shadow',
		sel: '.comp.compGrid._noAnchorGrid._LIGHTHIGH, .comp.compGrid ._anchorGrid._LIGHTHIGH',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design One',
		n: 'paddingDesignOne',
		dv: '10px 10px 10px 10px',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGONE, .comp.compGrid ._anchorGrid._PADDINGONE',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design Two',
		n: 'paddingDesignTwo',
		dv: '20px 20px 20px 20px',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGTWO, .comp.compGrid ._anchorGrid._PADDINGTWO',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design Three',
		n: 'paddingDesignThree',
		dv: '30px 30px 30px 30px',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGTHREE, .comp.compGrid ._anchorGrid._PADDINGTHREE',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design Four',
		n: 'paddingDesignFour',
		dv: '40px 40px 40px 40px',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGFOUR, .comp.compGrid ._anchorGrid._PADDINGFOUR',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design Five',
		n: 'paddingDesignFive',
		dv: '50px 50px 50px 50px',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGFIVE, .comp.compGrid ._anchorGrid._PADDINGFIVE',
		np: true,
	},
	{
		gn: 'Padding',
		dn: 'Padding Design Six',
		n: 'paddingDesignSix',
		dv: '60px 60px 60px 60px ',
		cp: 'padding',
		sel: '.comp.compGrid._noAnchorGrid._PADDINGSIX, .comp.compGrid ._anchorGrid._PADDINGSIX',
		np: true,
	},
];

export const styleDefaults = new Map<string, string>(
	styleProperties
		.filter(e => !!e.dv)
		.map(({ n: name, dv: defaultValue }) => [name, defaultValue!]),
);
